import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseData/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseData/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseData/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseData/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseData/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseData/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseData/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseData/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseData/update/batch',
    method: 'POST',
    data})
}

   